export var slice = Array.prototype.slice;



//////////////////
// WEBPACK FOOTER
// /home/mysticerp/domains/mysticerp.ro/public_html/mystic/agatexfe/~/d3-shape/src/array.js
// module id = ../../../../d3-shape/src/array.js
// module chunks = 4